import React from 'react';
import PropTypes from "prop-types";
import {ThemeProvider} from '@mui/material/styles';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';

import MuiInputTheme from '@/themes/mui/MuiInputTheme.js';


const MUIInput = React.forwardRef(({label, InputProps, fullWidth = false, size = null, errorMessage = '', ...props}, ref) => {
    const isValid = !(React.isValidElement(errorMessage) ? !!errorMessage : !!errorMessage?.length);

    if (fullWidth) {
        size = null;
    }

    return (
        <ThemeProvider theme={MuiInputTheme}>
            <FormControl fullWidth={fullWidth} className={size}>
                {label?.length > 0 && (
                    <InputLabel
                        id={props.name ? `${props.name}-input-label` : null}
                        htmlFor={props.name ? `${props.name}-input` : null}
                        error={!isValid}
                        shrink={true}
                    >
                        {(() => {
                            if (!isValid) {
                                return errorMessage
                            } else {
                                return label
                            }
                        })()}
                    </InputLabel>
                )}
                <OutlinedInput
                    id={props.name ? `${props.name}-input` : null}
                    autoComplete={'false'}
                    {...props}
                    inputRef={ref}
                    error={!!errorMessage.length}
                    inputProps={{
                        ...props.inputProps,
                    }}
                    onFocus={() => {
                        if (typeof props?.onFocus === "function") {
                            props.onFocus();
                        }
                    }}
                    onChange={(e) => {
                        // e.persist();
                        if (typeof props?.onChange === "function") {
                            props.onChange(e);
                        }
                    }}
                />
            </FormControl>
        </ThemeProvider>
    );
});

MUIInput.propTypes = {
    label: PropTypes.string,
    errorMessage: PropTypes.any,
};

export default MUIInput;
